var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"level-intro"}},[(_vm.alert)?_c('icon',{staticClass:"icon alert",attrs:{"name":"exclamation-triangle","scale":"4"}}):_c('icon',{staticClass:"icon success",attrs:{"name":"check-circle","scale":"4"}}),_vm._v(" "),_c('div',{staticClass:"text space-font-mono",domProps:{"innerHTML":_vm._s(_vm.unescapeSymbols(_vm.text))}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68b25e6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/objects/LevelIntro.vue
// module id = null
// module chunks = 